import { render } from "./FailedTransactions.vue?vue&type=template&id=39075493"
import script from "./FailedTransactions.vue?vue&type=script&lang=js"
export * from "./FailedTransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__